import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import Accordion from '@material-ui/core/Accordion';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Tooltip from '@material-ui/core/Tooltip';
import { DECORATING_TECHNIQUES } from 'shared/constants/decorating-techniques';
import { USD_TO_CAD_CONVERSION_RATE } from 'constants/currency';
import {
  AccordionSummary,
  AccordionDetails,
  useStyles,
} from 'styles/pages/product-detail/accordion';
import {
  ProductSizes,
  SizeBox,
  SizeName,
  Price,
  PricesUnit,
} from 'styles/pages/product-detail/size&price';

const getTitleFromDisplayName = (displayName) => {
  return _.find(DECORATING_TECHNIQUES, (v) => v?.DisplayName === displayName)
    ?.FullName;
};

const SizePrice = ({ data }) => {
  const classes = useStyles();
  const sizes = data?.Sizes || [];
  const currency = useSelector((state) => state?.currency?.value);

  return (
    <Accordion className={classes.accordion} defaultExpanded>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography className={classes.heading}>
          Available sizes & pricing
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ProductSizes>
          {sizes.map((size, index) => {
            const printTypeCost =
              Number(size.ColoredPrice || 0) +
              Number(size[`${data?.Product?.PrintType}Price`] || 0);
            const discountPrintTypeCost =
              (printTypeCost * (data?.discount || 0)) / 100;
            const actualPrintTypeCost = (
              printTypeCost - discountPrintTypeCost
            ).toFixed(2);

            const whitePrintTypeCost =
              Number(size?.WhitePrice || 0) +
              Number(size[`${data?.Product?.PrintType}Price`] || 0);

            const discountWhitePrintTypeCost =
              (whitePrintTypeCost * (data?.discount || 0)) / 100;

            const actualWhitePrintTypeCost = (
              whitePrintTypeCost - discountWhitePrintTypeCost
            ).toFixed(2);

            return size?.visible === false ? null : (
              <div key={`size${index}`} style={{ display: 'grid' }}>
                <SizeBox>
                  <SizeName>Size</SizeName>
                  <Price>Colored</Price>
                  {data?.Product?.PrintType !== 'AOP' &&
                    data?.Product?.PrintType !== 'SUB' && <Price>White</Price>}
                </SizeBox>
                <SizeBox style={{ marginBottom: 20 }}>
                  <Tooltip
                    title={`${getTitleFromDisplayName(
                      data?.Product?.PrintType
                    )}`}
                    placement="top"
                    arrow={true}
                  >
                    <SizeName>
                      {size.Name} with {data?.Product?.PrintType}
                    </SizeName>
                  </Tooltip>

                  <Price>
                    $
                    {currency === 'USD'
                      ? actualPrintTypeCost
                      : (
                          Number(actualPrintTypeCost) *
                          USD_TO_CAD_CONVERSION_RATE
                        ).toFixed(2)}
                  </Price>

                  {data?.Product?.PrintType !== 'AOP' &&
                    data?.Product?.PrintType !== 'SUB' && (
                      <Price>
                        $
                        {currency === 'USD'
                          ? actualWhitePrintTypeCost
                          : (
                              Number(actualWhitePrintTypeCost) *
                              USD_TO_CAD_CONVERSION_RATE
                            ).toFixed(2)}
                      </Price>
                    )}

                  {data?.RemainingDecorativeTechniques?.map((d) => {
                    const coloredPriceCost =
                      Number(size.ColoredPrice) +
                      Number(size[`${d?.DisplayName}Price`] || 0);
                    const discountColouredPrintTypeCost =
                      (coloredPriceCost * (data?.discount || 0)) / 100;
                    const actualColoredPrintTypeCost = (
                      coloredPriceCost - discountColouredPrintTypeCost
                    ).toFixed(2);

                    const whitePrintTypeCost =
                      Number(size.WhitePrice) +
                      Number(size[`${d?.DisplayName}Price`] || 0);

                    const discountWhitePrintTypeCost =
                      (whitePrintTypeCost * (data?.discount || 0)) / 100;

                    const actualWhitePrintTypeCost = (
                      whitePrintTypeCost - discountWhitePrintTypeCost
                    ).toFixed(2);

                    return (
                      <React.Fragment key={d?.DisplayName}>
                        <Tooltip
                          title={`${getTitleFromDisplayName(d?.DisplayName)}`}
                          placement="top"
                          arrow={true}
                        >
                          <SizeName>
                            {size.Name} with {d?.DisplayName}
                          </SizeName>
                        </Tooltip>

                        <Price>
                          $
                          {currency === 'USD'
                            ? actualColoredPrintTypeCost
                            : (
                                Number(actualColoredPrintTypeCost) *
                                USD_TO_CAD_CONVERSION_RATE
                              ).toFixed(2)}
                        </Price>
                        <Price>
                          $
                          {currency === 'USD'
                            ? actualWhitePrintTypeCost
                            : (
                                Number(actualWhitePrintTypeCost) *
                                USD_TO_CAD_CONVERSION_RATE
                              ).toFixed(2)}
                        </Price>
                      </React.Fragment>
                    );
                  })}
                </SizeBox>
              </div>
            );
          })}
        </ProductSizes>
        <PricesUnit>
          *Prices shown in {currency === 'USD' ? 'USD' : 'CAD'}
        </PricesUnit>
      </AccordionDetails>
    </Accordion>
  );
};

export default SizePrice;
